"use client";

import React from "react";
import styles from "./styles.module.scss";
import clsx from "clsx";
import { ButtonLoader } from "@components/travel-pass/button-loader";

interface ButtonProps {
  cta: string;
  type?: "success" | "danger" | "neutral" | "warning" | "info";
  onClick: (e: any) => void;
  disabled?: boolean;
  className?: string;
  style?: React.CSSProperties;
  disableShimmer?: boolean;
  transparent?: boolean;
  isLoading?: boolean;
  neutralOnDisabled?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  cta,
  type = "success",
  onClick,
  disabled,
  className,
  style,
  disableShimmer,
  isLoading,
  transparent,
  neutralOnDisabled,
}) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.currentTarget.blur();
    onClick?.(e);
  };
  return (
    <button
      className={clsx(
        styles.button,
        styles[type],
        className,
        transparent ? styles.transparent : "",
        neutralOnDisabled ? styles.neutralOnDisabled : ""
      )}
      onClick={handleClick}
      disabled={disabled}
      style={style}>
      {isLoading ? <ButtonLoader /> : <span className={styles.label}>{cta}</span>}

      {!disabled && !disableShimmer && <span className={styles.shimmer}></span>}
    </button>
  );
};

export default Button;
